export enum CursorEventType {
  MOVE = "move",
  REMOVE = "remove",
  CLICK = "click",
}

export type CursorEventMove = {
  type: CursorEventType.MOVE;
  rX: number;
  rY: number;
};

type CursorEventRemove = {
  type: CursorEventType.REMOVE;
};

type CursorEventClick = {
  type: CursorEventType.CLICK;
  rX: number;
  rY: number;
};

export type CursorEvent =
  | CursorEventMove
  | CursorEventRemove
  | CursorEventClick;

export type CursorResp = {
  connId: string;
  event: CursorEvent;
};
